import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AdminShell from "@/components/admin/AdminShell";
import BookingForm from "@/components/admin/BookingForm";
import { bookingToForm, createBooking, createBookingsWithExtras, emptyBookingForm, getBooking, type BookingFormInput, type ExtraDate } from "@/lib/bookingsApi";
import { defaultDueDate } from "@/lib/bookingLabels";
import { useAuth } from "@/contexts/AuthContext";

const BookingNew = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { user } = useAuth();
  const [saving, setSaving] = useState(false);
  const initial = useMemo(() => {
    const base = emptyBookingForm(7);
    const date = params.get("date");
    if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      base.performance_date = date;
      base.due_date = defaultDueDate(date, 7);
    }
    return base;
  }, [params]);
  const [copied, setCopied] = useState<BookingFormInput | null>(null);
  const fromId = params.get("from");
  useEffect(() => {
    if (!fromId) return;
    void getBooking(fromId).then((r) => {
      if (r.ok === false) return;
      const f = bookingToForm(r.data);
      setCopied({
        ...f,
        performance_date: "",
        date_tbc: false,
        due_date: "",
        payment_status: "awaiting",
        booking_status: "scheduled",
      });
    });
  }, [fromId]);

  const save = async (
    values: Parameters<typeof createBooking>[0],
    extras: ExtraDate[],
    andSend = false
  ) => {
    setSaving(true);
    const res = await createBookingsWithExtras(values, extras, user?.id);
    setSaving(false);
    if (res.ok === false) throw new Error(res.error);
    const id = res.data.first.id;
    navigate(
      andSend
        ? `/admin/bookings/${id}?send=1`
        : `/admin/bookings/${id}`,
      { replace: true }
    );
  };

  return (
    <AdminShell title={copied ? "Copy of booking" : "New Booking"}>
      <BookingForm
        mode="create"
        initial={copied ?? initial}
        saving={saving}
        onSave={(v, x) => save(v, x, false)}
        onSaveAndSend={(v, x) => save(v, x, true)}
      />
    </AdminShell>
  );
};

export default BookingNew;
